import { render, staticRenderFns } from "./CtaList.vue?vue&type=template&id=4fd59431&scoped=true"
import script from "./CtaList.vue?vue&type=script&lang=js"
export * from "./CtaList.vue?vue&type=script&lang=js"
import style0 from "./CtaList.vue?vue&type=style&index=0&id=4fd59431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd59431",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
